export default {
  methods: {
    async getRecaptchaToken(action) {
      await this.$recaptchaLoaded();
      return this.$recaptcha(action);
    },
  },
};
